:host {
    display: flex;
    align-items: center;
    color: var(--color-info);
}

es-icon {
    animation-name: es-loading-dot;
    animation-duration: 4000ms;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(1, 0, 0, 1);
    opacity: 0;
    transform: scale(0);
}

es-icon:nth-of-type(1) {
        animation-delay: -4000ms;
    }

es-icon:nth-of-type(2) {
        animation-delay: -3200ms;
    }

es-icon:nth-of-type(3) {
        animation-delay: -2400ms;
    }

es-icon:nth-of-type(4) {
        animation-delay: -1600ms;
    }

es-icon:nth-of-type(5) {
        animation-delay: -800ms;
    }

@keyframes es-loading-dot {
    20% {
        transform: scale(0) translateX(-150%);
        opacity: 0;
    }
    50% {
        transform: scale(1) translateX(0%);
        opacity: 1;
    }
    80% {
        transform: scale(0) translateX(150%);
        opacity: 0;
    }
}
